import { PayloadAction } from "@reduxjs/toolkit";
import { VendorsState } from "../../models/VendorsState";
import { ConfirmVendorPayload } from "../../payload/ConfirmVendor/ConfirmVendorPayload";

const confirmVendorFetch = (state: VendorsState, action: PayloadAction<ConfirmVendorPayload>) => {
    state.isLoading = true;
}

export default confirmVendorFetch;